var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNomad = function SvgNomad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.273 6.172 0 13.328v14.316L12.265 34.8l12.273-7.156V13.328L12.273 6.172Zm5.476 15.75L14.48 23.83l-3.95-2.183v4.563l-3.711 2.38v-9.535l2.948-1.822 4.086 2.175V14.75l3.896-2.367v9.54Z",
    fill: "#00CA8E"
  })));
};

export default SvgNomad;